import { render, staticRenderFns } from "./MtProducts.vue?vue&type=template&id=bbbf06b4&"
import script from "./MtProducts.vue?vue&type=script&lang=js&"
export * from "./MtProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports